import ActionType from "./globalActionType";

const globalState = {
    login: false,
    sign: null,
    token: null,
    internalToken: null,
    refreshToken: null,
    userDetail: null,
    tncAccepted: null
}

const authenticationReducer = (state = globalState, action) => {
    switch (action.type) {
        case ActionType.IS_LOGIN:
            return {
                login: true,
                sign: action.payload.sign,
                token: action.payload.token,
                internalToken: action.payload.internalToken,
                refreshToken: action.payload.refreshToken,
                userDetail: action.payload.userDetail,
                tncAccepted: action.payload.tncAccepted ?? null
            };
        case ActionType.IS_LOGOUT:
            return {
                login: false,
                sign: null,
                token: null,
                internalToken: null,
                refreshToken: null,
                userDetail: null,
                tncAccepted: null
            };
        case ActionType.UPDATE_PROFILE:
            return {
                ...state,
                userDetail: action.payload.userDetail
            };
        case ActionType.UPDATE_TNC_ACCEPTANCE:
            return {
                ...state,
                tncAccepted: action.payload.tncAccepted
            };
        default:
            return state;
    }
}

export default authenticationReducer;
